import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5b895e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-signup" }
const _hoisted_2 = { class: "page-wrapper" }
const _hoisted_3 = { class: "page-container" }
const _hoisted_4 = { class: "page-headline" }
const _hoisted_5 = { class: "page-block" }
const _hoisted_6 = { class: "auth-signup__step signup-success" }
const _hoisted_7 = { class: "auth-signup__announcement" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-signup__announcement-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "email sent icon",
    src: "/img/icons/email-sent--orange.svg"
  })
], -1))
const _hoisted_9 = { class: "auth-signup__announcement-title" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxSteps = _resolveComponent("PxSteps")!
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("supporters.signup.startMessage")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_PxSteps, {
            active: _ctx.currentStep,
            steps: _ctx.items,
            theme: "orange"
          }, null, 8, ["active", "steps"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_PxPanel, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("supporters.signup.success.title")), 1),
                  _createElementVNode("div", {
                    class: "auth-signup__announcement-message",
                    innerHTML: 
                    _ctx.$t('supporters.signup.success.message', {
                      registrationEmail: _ctx.registrationEmail,
                    })
                  
                  }, null, 8, _hoisted_10)
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}